export default [{
        path: '/logisticsTrade',
        name: 'logisticstrade',
        component: resolve => require(['@/components/home/logisticsTrade.vue'], resolve),
        meta: {
            title: '物流交易'
        }
    }, {
        path: '/logisticsPark',
        name: 'logisticspark',
        component: resolve => require(['@/components/home/logisticsPark.vue'], resolve),
        meta: {
            title: '物流园区'
        }
    }, {
        path: '/logisticsLine',
        name: 'logisticsline',
        component: resolve => require(['@/components/home/logisticsLine.vue'], resolve),
        meta: {
            title: '物流专线'
        }
    },
    {
        path: '/logisticsWarehouse',
        name: 'logisticswarehouse',
        component: resolve => require(['@/components/home/logisticsWarehouse.vue'], resolve),
        meta: {
            title: '仓储物流'
        }
    },
    {
        path: '/logisticsDirectories',
        name: 'logisticsdirectories',
        component: resolve => require(['@/components/home/logisticsDirectories.vue'], resolve),
        meta: {
            title: '物流分类'
        }
    },
    {
        path: '/logisticsNews',
        name: 'logisticsnews',
        component: resolve => require(['@/components/home/logisticsNews.vue'], resolve),
        meta: {
            title: '热点新闻'
        }
    },
    {
        path: '/logisticsNewsDetail',
        name: 'logisticsnewsdetail',
        component: resolve => require(['@/components/home/logisticsNewsDetail.vue'], resolve),
        meta: {
            title: '物流资讯详情'
        }
    },
    {
        path: '/logisticsJob',
        name: 'logisticsjob',
        component: resolve => require(['@/components/home/logisticsJob.vue'], resolve),
        meta: {
            title: '物流招聘'
        }
    },
    {
        path: '/aboutUs',
        name: 'aboutus',
        component: resolve => require(['@/components/home/aboutUs.vue'], resolve),
        meta: {
            title: '关于我们'
        }
    },
    {
        path: '/dynamic',
        name: 'dynamic',
        component: resolve => require(['@/components/home/dynamic.vue'], resolve),
        meta: {
            title: '本网动态'
        }
    },
    {
        path: '/proclamation',
        name: 'proclamation',
        component: resolve => require(['@/components/home/proclamation.vue'], resolve),
        meta: {
            title: '通知公告'
        }
    },
    {
        path: '/version',
        name: 'version',
        component: resolve => require(['@/components/home/version.vue'], resolve),
        meta: {
            title: '版本迭代'
        }
    },
    {
        path: '/nodeList',
        name: 'nodelist',
        component: resolve => require(['@/components/home/nodeList.vue'], resolve),
        meta: {
            title: '物流县区节点'
        }
    },
    {
        path: '/committee',
        name: 'committee',
        component: resolve => require(['@/components/home/committee.vue'], resolve),
        meta: {
            title: '行业物流专委会'
        }
    },
    {
        path: '/association',
        name: 'association',
        component: resolve => require(['@/components/home/association.vue'], resolve),
        meta: {
            title: '物流协会'
        }
    },
    {
        path: '/associationApply',
        name: 'associationapply',
        component: resolve => require(['@/components/home/associationApply.vue'], resolve),
        meta: {
            title: '入会申请'
        }
    },
    {
        path: '/committeeList',
        name: 'committeelist',
        component: resolve => require(['@/components/home/committeeList.vue'], resolve),
        meta: {
            title: '行业专委会'
        }
    },
    {
        path: '/newsletters',
        name: 'newsletters',
        component: resolve => require(['@/components/home/newsletters.vue'], resolve),
        meta: {
            title: '协会动态'
        }
    },
    {
        path: '/newslettersDetail',
        name: 'newslettersdetail',
        component: resolve => require(['@/components/home/newslettersDetail.vue'], resolve),
        meta: {
            title: '协会动态详情'
        }
    },
    {
        path: '/distribution',
        name: 'distribution',
        component: resolve => require(['@/components/home/distribution.vue'], resolve),
        meta: {
            title: '物流资源分布图'
        }
    },
    {
        path: '/logisticsIndustry',
        name: 'logisticsIndustry',
        component: resolve => require(['@/components/home/menuList/logisticsIndustry.vue'], resolve),
        meta: {
            title: '物流行业'
        }
    },
    {
        path: '/platformRecommend',
        name: 'platformRecommend',
        component: resolve => require(['@/components/home/menuList/platformRecommend.vue'], resolve),
        meta: {
            title: '平台推荐'
        }
    },
    {
        path: '/companyRecommend',
        name: 'companyRecommend',
        component: resolve => require(['@/components/home/menuList/companyRecommend.vue'], resolve),
        meta: {
            title: '名企推荐'
        }
    },
    {
        path: '/informationRecommend',
        name: 'informationRecommend',
        component: resolve => require(['@/components/home/menuList/informationRecommend.vue'], resolve),
        meta: {
            title: '资讯推荐'
        }
    },
    {
        path: '/platformDetails',
        name: 'platformDetails',
        component: resolve => require(['@/components/home/menuList/platformDetails.vue'], resolve),
        meta: {
            title: '平台推荐详情'
        }
    },
    {
        path: '/inforDetails',
        name: 'inforDetails',
        component: resolve => require(['@/components/home/menuList/informationDetails.vue'], resolve),
        meta: {
            title: '资讯推荐详情'
        }
    },
    {
        path: '/industryIndex',
        name: 'industryIndex',
        component: resolve => require(['@/components/home/menuList/industryIndex.vue'], resolve),
        meta: {
            title: '物流行业'
        }
    },
    {
        path: '/logisticsIndex',
        name: 'logisticsIndex',
        component: resolve => require(['@/components/home/menuList/logisticsIndex.vue'], resolve),
        meta: {
            title: '行业物流'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/modules/frontRouter.js